import React, {Component} from 'react';
import FormView from './FormView'
import {FormViewContainer} from '../../../components/Letflow/ViewContainer';
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";

class FormContainer extends Component {

  state = {
    nameEs: '',
    nameEn: '',
    namePt: '',
    tagGroupType: '',
    tagGroupId: '',
    selectedTagGroup: "",
    order: '',
    showOnSmartSearch: true,
    types: [],
  }

  componentDidMount = () => {
      if (this.props.formType === 'create') {
        this.requestContentCreatorTypes()
      }
  }

  requestContentCreatorTypes = () =>
    request.contentCreatorType.getAll({filterBy: [
      {column: "type", filter: this.props.isTalent ? 'talent' : this.props.isAudiovisual ? 'audiovisual' : 'editorial'},
      ]})
      .then(contentCreatorTypes => {
        let types = contentCreatorTypes.map(contentCreatorType => ({value: contentCreatorType.slug, label: contentCreatorType.name}))
        this.setState({types})
      })

  setTag = tag => {
    let translationEs = tag.translations.find(translation => translation.locale === 'es')
    let translationEn = tag.translations.find(translation => translation.locale === 'en')
    let translationPt = tag.translations.find(translation => translation.locale === 'pt')
    let tagGroupType = ''
    this.requestContentCreatorTypes()
      .then(() => {
        this.state.types.forEach(type => {
          if (tag.group.types[0] && type.value === tag.group.types[0].type){
            tagGroupType = type
          }
        })
      })
      .then(() => {
        this.setState({
          nameEs: translationEs && translationEs.name,
          nameEn: translationEn && translationEn.name,
          namePt: translationPt && translationPt.name,
          selectedTagGroup: {value: tag.group.id, label: tag.group.name, types: tag.group.types},
          tagGroupType: tagGroupType,
          order: tag.order,
          showOnSmartSearch: tag.show_on_smart_search
        })
      })
  }

  onChange = e => this.setState({ [e.target.id]: e.target.value })

  submitRequest = () => this.props.submitRequest(this.state)

  altSubmitRequest = () => {
    return this.props.submitRequest({...this.state, altSubmit: true})
      .then(() => this.setState({
        ...this.state,
        nameEs: '',
        nameEn: '',
        namePt: '',
        order:'',
        showOnSmartSearch: true,
      }))
  }

  altSubmitValidation = () => {
    if (!this.state.nameEn || !this.state.nameEs || !this.state.namePt) {
      GlobalSnackbar.show({message: localization.get('form.missing_required_translation'), type: GlobalSnackbarTypes.ERROR});
      return false
    } else {
      return true
    }
  }

  render = () => {

    const { nameEs, nameEn, namePt, tagGroupId, tagGroupType, tagGroups, order, types, showOnSmartSearch } = this.state

    const { disabled, disableTagGroups } = this.props

    return (
      <FormViewContainer
        title={this.props.title}
        submitRequest={this.submitRequest}
        altSubmitRequest={this.altSubmitRequest}
        altSubmitValidation={this.altSubmitValidation}
        altSubmit={this.props.altSubmit}
        onBack={() => this.props.history.goBack()}
        onRequestingStateChanged={value => this.setState({ disabled: value })}
        hasTranslatableInputs
      >
        <FormView
          ref={instance => this.child = instance}
          disabled={disabled}
          nameEs={nameEs}
          nameEn={nameEn}
          namePt={namePt}
          tagGroupType={tagGroupType}
          tagGroupId={tagGroupId}
          onChange={this.onChange}
          selectedTagGroup={this.state.selectedTagGroup}
          disableTagGroups={disableTagGroups}
          onTagGroupChange={selectedTagGroup => this.setState({selectedTagGroup})}
          onTagCategoryChange={tagGroupType => this.setState({tagGroupType: '', selectedTagGroup: ''}, () => this.setState({tagGroupType}))}
          order={order}
          types={types}
          showOnSmartSearch={showOnSmartSearch}
          onShowOnSmartSearchChange={() => this.setState({showOnSmartSearch: !showOnSmartSearch})}
        />
      </FormViewContainer>
    )
  }
}

export default FormContainer
